const EmailValidator = (emailValue: string | undefined): IEmailValidatorResult => {
    if (!emailValue) {
        return {
            passed: false,
            error: "Enter an email",
        };
    }
    const isEmailValid = isValidEmail(emailValue);
    if (!isEmailValid) {
        return { passed: false, error: "Not a valid email" };
    }
    return { passed: true };
};

export function isValidEmail(emailValue: string, allowMultiple = true): boolean {
    const isMultipleEmails = (emailValue || "").includes(";");
    if (!allowMultiple || !isMultipleEmails) {
        return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            emailValue.trim()
        );
    }
    const emails = emailValue.split(";");
    const invalidEmails = emails.filter((e) => !isValidEmail(e));
    return invalidEmails.length === 0;
}

interface IEmailValidatorResult {
    passed: boolean;
    error?: EmailValidatorError;
}

type EmailValidatorError = "Enter an email" | "Not a valid email" | "Email already taken";

export default EmailValidator;
export type { IEmailValidatorResult };
